import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-473dcca8")

_pushScopeId("data-v-473dcca8")
const _hoisted_1 = { class: "app-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "notice-publish-card",
      shadow: "never"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          class: "notice-publish-form",
          model: _ctx.form,
          rules: _ctx.rules,
          "label-width": "100px"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('table.noticePublishTimeRange'),
              prop: "date"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.form.date,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.date = $event)),
                  type: "datetimerange",
                  format: "YYYY-MM-DD HH:mm:ss",
                  "value-format": "YYYY-MM-DD HH:mm:ss",
                  "range-separator": "—",
                  "start-placeholder": _ctx.t('input.imeiBindRecordStartDate'),
                  "end-placeholder": _ctx.t('input.imeiBindRecordEndDate'),
                  "disabled-date": _ctx.disabledNoticeDate,
                  style: {"width":"520px"}
                }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "disabled-date"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('table.noticePublishContent'),
              prop: "content"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.content,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.content = $event)),
                  type: "textarea",
                  autosize: { minRows: 2, maxRows: 6 },
                  maxlength: "600",
                  "show-word-limit": "",
                  placeholder: _ctx.t('table.noticePublishContentPlaceholder'),
                  style: {"max-width":"560px"}
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: _ctx.submitting,
                  onClick: _ctx.onSubmit
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("table.noticePublishSubmit")), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    })
  ]))
})